var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPrizeDraw40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrizeDraw40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trophy-picto"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(11.000000, 10.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L15,0 L15,9 C15,12.3137085 12.3137085,15 9,15 C5.6862915,15 3,12.3137085 3,9 L3,0 L3,0 Z",
    id: "Rectangle",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.5,3 L3.5,3 L3.5,4 C3.5,5.1045695 2.6045695,6 1.5,6 C0.3954305,6 -0.5,5.1045695 -0.5,4 L-0.5,3 L-0.5,3 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(1.500000, 4.500000) rotate(90.000000) translate(-1.500000, -4.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,3 L18.5,3 L18.5,4 C18.5,5.1045695 17.6045695,6 16.5,6 C15.3954305,6 14.5,5.1045695 14.5,4 L14.5,3 L14.5,3 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(16.500000, 4.500000) scale(-1, 1) rotate(90.000000) translate(-16.500000, -4.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 20,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 19.5,
    x2: 13,
    y2: 19.5,
    id: "Path-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPrizeDraw40);
export default __webpack_public_path__ + "static/media/pictogramBeaconPrizeDraw40.b2abc71da23a568b9afe68888c3172e7.svg";
export { ForwardRef as ReactComponent };